import React from 'react';

import type { OrderDetailsFieldView } from '@src/features/orders/details/types';

import { OrderDetailsFieldValue } from './OrderDetailsFieldValue';
import { OrderDetailsFieldLabel, OrderDetailsFieldRoot } from './styles';

export type OrderDetailsFieldProps = {
  field: OrderDetailsFieldView;
};

export const OrderDetailsField = (props: OrderDetailsFieldProps) => {
  const { field } = props;

  return (
    <OrderDetailsFieldRoot data-testid={`order-details-field-${field.key}`}>
      <OrderDetailsFieldLabel>{field.label}</OrderDetailsFieldLabel>
      <OrderDetailsFieldValue value={field.value} adornment={field.adornment} />
    </OrderDetailsFieldRoot>
  );
};

export default OrderDetailsField;
